import { render, staticRenderFns } from "./ValidacionFraude.vue?vue&type=template&id=3b829729&"
import script from "./ValidacionFraude.vue?vue&type=script&lang=js&"
export * from "./ValidacionFraude.vue?vue&type=script&lang=js&"
import style0 from "./ValidacionFraude.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports